<div class="share_wrapper">
    <div class="share_header">
        <h2 rds-dialog-title>Share Project : {{ projectName }}</h2>
        <button rds-icon-button size="m" (click)="close()">
            <rds-icon icon="close" namespace="outlined"></rds-icon>
        </button>
    </div>

    <div class="share_content">
        <!-- Invite Collaborators Section -->
        <div class="content-card collapsible-section">
            <div class="section-header">
                <div class="invite-label-wrapper">
                    <label class="form-label">Invite Collaborators to the Project (Enter at least 3 characters to
                        search)</label>
                    <rds-icon
                        class="roles-info-icon"
                        namespace="filled"
                        icon="circle_info"
                        [rdsTooltip]="resourceConstant.rolesDescriptionTooltip"
                        (click)="openRolesDescription()">
                    </rds-icon>
                </div>
            </div>
            <div class="section-content">
                <div class="email-wrapper">
                    <div class="typeahead-container">
                        <app-typeahead-input [rdsTooltip]="isDisabled() ?  resourceConstant.noAccessText : ''"
                            [disabled]="isDisabled()" class="form-input" placeholder="Search user(s)"
                            [suggestions]="userSuggestions" [isLoading]="isSearchingUsers"
                            [noResultsFound]="noUsersFound" [initialSelectedUsers]="selectedUsersToInvite"
                            (selectedUsersChange)="onSelectedUsersChange($event)"
                            (searchChange)="onUserSearchChange($event)" [existingUserList]="existingUserSuggestions">
                        </app-typeahead-input>

                    </div>
                    <div class="dropdown-field" [class.disabled]="isDisabled()"
                        [rdsTooltip]="isDisabled() ? resourceConstant.noAccessText : ''">
                        <div rds-dropdown [autoClose]="true" placement="bottom-left">
                            <button [disabled]="isDisabled()" class="dropdown-btn" rdsDropdownToggle>
                                <span>{{ inviteRole }}</span>
                                <rds-icon namespace="outlined" icon="chevron_down"></rds-icon>
                            </button>
                            <div *rdsDropdownMenu class="dropdown-menu-container">
                                @for (role of roles; track role) {
                                <span>
                                    <div class="dropdown-item" [class.active]="inviteRole === role"
                                        (click)="selectInviteRole(role)">
                                        {{ role }}
                                    </div>
                                </span>
                                }
                            </div>
                        </div>
                    </div>
                    <div class="add-user-btn">
                        <span 
                            [rdsTooltip]="
                            selectedUsersToInvite.length === 0 ||
                            !inviteRole ||
                            isInviting
                                ? 'No changes made'
                                : ''
                        ">
                            <button [class.copy-link-disabled]="selectedUsersToInvite.length === 0 || !inviteRole || isInviting"
                                [disabled]="selectedUsersToInvite.length === 0 || !inviteRole || isInviting" (click)="inviteUser()"
                                class="footer-btn save-btn">
                                <span>Add</span>
                            </button>
                        </span>            
                    </div>
                </div>
            </div>
        </div>

        <!-- People with Access Section -->
        <div class="content-card collapsible-section">
            <div class="section-header">
                <label class="form-label">People with Access Roles for Study Design and Trial Simulation</label>
                <span class="collaborators-count" *ngIf="users.length > 1">{{ users.length }} collaborators</span>
            </div>
            <div class="section-content">
                <div class="filter-row">
                    <div class="filter-input">
                        <div class="input-container">
                            <rds-icon namespace="outlined" icon="search" class="search-icon"></rds-icon>
                            <input type="text" class="form-input" [(ngModel)]="searchText"
                                placeholder="Search for People within the Project" (input)="onSearchInput($event)" />
                        </div>
                    </div>
                    <div class="filter-role">
                        <div class="dropdown-field" rds-dropdown [autoClose]="true" placement="bottom-left">
                            <button class="dropdown-btn" rdsDropdownToggle>
                                <span>{{ filterRole }}</span>
                                <rds-icon namespace="outlined" icon="chevron_down"></rds-icon>
                            </button>
                            <div *rdsDropdownMenu class="dropdown-menu-container">
                                <div class="dropdown-item" [class.active]="filterRole === 'All Roles'"
                                    (click)="selectFilterRole('All Roles')">
                                    All Roles
                                </div>
                                @for (role of filterRoles; track role) {
                                <div class="dropdown-item" [class.active]="filterRole === role"
                                    (click)="selectFilterRole(role)">
                                    {{ role }}
                                </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div class="filter-placeholder"></div>
                </div>

                <div class="user-list-wrapper" #userListWrapper [class.has-scrollbar]="hasScrollbar">
                    @if (isLoading) {
                    <div class="loading-spinner">
                        <rds-progress-spinner diameter="32"></rds-progress-spinner>
                    </div>
                    } @else if (filteredUsers.length === 0) {
                    <div class="no-results">No users found</div>
                    } @else {
                    @for (user of filteredUsers; track user.email) {
                    <div class="user-row">
                        <div class="column user-column">
                            <div class="user-info">
                                <rds-avatar size="m" [rdsTooltip]="user.name">
                                    <span rds-avatar-initials>{{ getInitials(user.name) }}</span>
                                </rds-avatar>
                                <div class="user-details">
                                    <div class="user-name-row">
                                        <span class="user-name">{{ user.name }}</span>
                                        <span *ngIf="isUserOnline(user.user_id)" class="active-dot"
                                            rdsTooltip="Currently Online" rdsTooltipPosition="top-center"></span>
                                    </div>
                                    <span class="user-email">{{ user.email }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="column role-column">
                            <div class="dropdown-field" [class.disabled]="isDisabled(user.role)"
                                [rdsTooltip]="getDisabledTooltip(user.role)" rds-dropdown [autoClose]="true"
                                placement="bottom-left">
                                <button class="dropdown-btn" [disabled]="isDisabled(user.role)" rdsDropdownToggle>
                                    <span>{{ user.role }}</span>
                                    <rds-icon namespace="outlined" icon="chevron_down"></rds-icon>
                                </button>
                                <div *rdsDropdownMenu class="dropdown-menu-container">
                                    @for (role of roles; track role) {
                                    <span>
                                        <div class="dropdown-item" [class.active]="user.role === role"
                                            (click)="updateUserRole(user, role)">
                                            {{ role }}
                                        </div>
                                    </span>
                                    }
                                </div>
                            </div>
                        </div>
                        <div class="column action-column">
                            <div class="context-menu" rds-dropdown [autoClose]="true"
                                placement="bottom-right">
                                <button rds-dropdown-toggle-icon-button size="s">
                                    <rds-icon icon="more_vertical" namespace="outlined"></rds-icon>
                                </button>
                                <div *rdsDropdownMenu class="context-menu-container">
                                    <!-- Remove from Project: shown for other users (not current user) -->
                                    <span *ngIf="!isCurrentUser(user)"
                                        [rdsTooltip]="getDisabledTooltip(user.role)"
                                        [class.disabled]="isDisabled(user.role)">
                                        <button rds-list-item (click)="removeUser(user)"
                                            [disabled]="isDisabled(user.role)"
                                            class="delete-option">
                                            <rds-icon icon="delete" namespace="outlined"></rds-icon>
                                            <span>Remove from Project</span>
                                        </button>
                                    </span>
                                    <!-- Leave Project: shown for current user -->
                                    <span *ngIf="isCurrentUser(user)" class="leave-project-container">
                                        <button rds-list-item (click)="leaveProject()"
                                            class="leave-option">
                                            <rds-icon namespace="filled" icon="logoff"></rds-icon>
                                            <span>Leave Project</span>
                                        </button>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                    }
                </div>
            </div>
        </div>
    </div>

    <div class="dialog-footer" *ngIf="showOwnerMessageAlert || showEditorSelfRoleAlert || showMaxOwnerAlert">
        <span *ngIf="showOwnerMessageAlert" class="footer-owner-msg">
            {{resourceConstant.minOwnerRequired}}
        </span>
        <span *ngIf="showEditorSelfRoleAlert" class="footer-owner-msg">
            {{ resourceConstant.editorSelfRoleChange }}
        </span>
        <span *ngIf="showMaxOwnerAlert" class="footer-owner-msg max-owner">
            {{ maxOwnersMessage }}
        </span>
    </div>
</div>
